<template>
  <b-card header="Update Tier">
    <div v-if="patron == false && is_server_premium == false">
      <h4 class="smalltitle">Get Premium</h4>
      <p>Hey there, this feature is only available on Premium</p>
      <div
        class="d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mt-3"
      >
        <PatreonPremiumButton
          class="mb-1 mb-md-0 mr-sm-0 mr-md-2"
          @track="trackPremiumCTA"
        />
        <DiscordPremiumButton @track="trackPremiumCTA" />
      </div>
    </div>
    <div v-if="patron == false && is_server_premium == true">
      <h4 class="smalltitle">Hey There!</h4>
      <hr />
      <p>
        Your server has premium from a legacy tier enabled by another user, this
        feature is only available on our new tiers. Please ask them to upgrade
        to one of our new tiers.
      </p>
      <b-button variant="success" @click="redirectToPatreon"
        >Upgrade Tier</b-button
      >
    </div>
    <div v-else>
      <h4 class="smalltitle">Hey there!</h4>
      <hr />
      <p>
        It looks like you have premium from a discontinued patron tier. Please
        upgrade to one of our new tiers to access this feature.
      </p>
      <b-button variant="success" @click="redirectToPatreon"
        >Upgrade Tier</b-button
      >
    </div>
  </b-card>
</template>

<script>
import features from "./premium-features.json";
import DiscordPremiumButton from "../../components/DiscordPremiumButton.vue";
import PatreonPremiumButton from "../../components/PatreonPremiumButton.vue";

export default {
  name: "TierCard",
  props: ["patron", "add_premium", "is_server_premium"],
  components: {
    DiscordPremiumButton,
    PatreonPremiumButton,
  },
  data() {
    return {
      features,
    };
  },
  methods: {
    redirectToPatreon() {
      window.location.href = "https://www.patreon.com/cw/carlbot/membership";
    },
  },
};
</script>

<style>
.premium-features-list {
  padding-left: 1.2rem;
  padding-right: 1.2rem;
  margin: 0 auto;
  max-width: 100%;
  font-size: 1rem;
  line-height: 1.5;
  word-break: break-word;
}
.premium-features-list li {
  margin-bottom: 0.75em;
}
@media (max-width: 575.98px) {
  .premium-features-list {
    font-size: 0.95rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
  }
}
</style>
